<template>
  <div class="trans">
    <Header />
    <section class="register-page section-b-space mt90">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
              <form class="theme-form" v-on:submit="checkForm" method="post">
                <div v-if="errors.length">
                  <ul class="validation-error mb-3">
                    <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
                  </ul>
                </div>
                <h2 class="text-center register-title">Your Name</h2>
                <div class="w-90">
                  <div class="form-group">
                    <label for="fname" class="border-label"><i class="fa fa-user"></i></label>
                    <input
                        type="text"
                        class="bottom-input"
                        id="fname"
                        v-model="fname"
                        placeholder="First Name"
                        name="fname"
                        required
                    />
                  </div>
                  <div class="form-group mb-5">
                    <label for="lname" class="border-label"><i class="fa fa-user"></i></label>
                    <input
                        type="text"
                        class="bottom-input"
                        id="lname"
                        v-model="lname"
                        placeholder="Last Name"
                        name="lname"
                        required
                    />
                  </div>

                  <div class="form-group university_select">
                    <select class="form-control" @change="changeUniversity($event)">
                    <option value="" selected disabled>Please Select Location</option>
                    <option v-for="university in universities" :value="university.universityid" :key="university.universityid">{{ university.universityname }}</option>
                    </select>
                  </div>

                  <div class="form-group d-flex justify-content-center">

                    <template v-if="next_button_disabled === false">
                      <input
                          type="submit"
                          class="btn btn-register mt-5"
                          value="Continue"
                      >
                    </template>
                    <template v-else>
                      PLEASE WAIT ...
                    </template>
                  </div>

                  <Pagination :number="4" />
                </div>
              </form>
          </div>
        </div>
      </div>
    </section>
    <Footer />
  </div>
</template>

<script>
import Header from '../../components/header'
import Footer from '../../components/footer'
import Pagination from '../../components/widgets/dot-pagination'

import {signIn} from '@/utils/auth.js'
import {mapGetters} from "vuex";

export default {
  components: {
    Header,
    Footer,
    Pagination
  },
  data() {
    return {
      errors: [],
      fname: "",
      lname: "",
      delayTimer: null,
      next_button_disabled: false,
      universities: [
        {'universityid':1, 'universityname':'USC'},   // Hardcoded initially, will send from backend later
        {'universityid':2, 'universityname':'UCLA/Westwood'},
        // {'universityid':4, 'universityname':'UCSB/Santa Barbara'},
        // Hi Christian can we please take the option for “other” off of the location tab. Thanks  2/27/2023 Henry
        // {'universityid':9999, 'universityname':'Other'},
      ],
      selectedUniversityId: -1,
    }
  },
  computed: {
    ...mapGetters({
      registration_data: 'auth/getRegistrationData',
    }),
  },
  mounted() {
    this.$store.dispatch('auth/setSigninLog',{type: 'signup_page_3_opened', 'signinusername': ''});
  },
  methods: {

    changeUniversity (event) {
      this.selectedUniversityId = event.target.options[event.target.options.selectedIndex].value;
    },

    startButtonDelayTimer: function () {
      this.delayTimer = setInterval(function () {
        clearInterval(this.delayTimer);
        if(this.next_button_disabled === false) { // multiple clicks create big problems, this solves it !!
          this.next_button_disabled = true;
          this.$store.dispatch("setGlobalError", {value: ""});
          this.$store.dispatch('auth/setRegistrationPart3', {first_name: this.fname, last_name: this.lname, university_id: this.selectedUniversityId})
          this.$store.dispatch('auth/setSigninLog', {
            type: 'signup_page_3',
            'signinusername': '|first_name=' + this.fname + '|lastname=' + this.lname + '|' + 'username=' + this.registration_data.user_name.toLowerCase()
          });
          signIn(this.registration_data.user_name, this.registration_data.password, this.$store, 1);
        }
      }.bind(this), 200);
    },
    checkForm: function (e) {
      this.errors = []

      if (!this.fname) {
        this.errors.push('First Name Required.')
      }
      if (!this.lname) {
        this.errors.push('Last Name Required.')
      }
      if(this.selectedUniversityId === -1) {
        this.errors.push('Please select your Location')
      }

      e.preventDefault();
      if (!this.errors.length) {
        this.startButtonDelayTimer();
      }
    },
  }
}
</script>


<style scoped>

.university_select select {
  font-size: 12px;
}

</style>
